import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { FaMapMarkerAlt } from 'react-icons/fa';

function WidGetTouch() {
    return (
        <div className="single-footer-wid site_info_widget">
            <div className="wid-title">
                <h4>Main Branch (Banjarmasin)</h4>
            </div>
            <div className="contact-us">
                <div className="single-contact-info">
                    <div className="icon">
                        <AiOutlinePhone />
                    </div>
                    <div className="contact-info">
                        <span>Phone / WhatsApp</span>
                        <p>0511 – 674 2881</p>
                        <p>+62 811 519 0088</p>
                    </div>
                </div>
                <div className="single-contact-info">
                    <div className="icon">
                        <AiOutlineMail />
                    </div>
                    <div className="contact-info">
                        <span>Email Address</span>
                        <p>kjd_bjm@yahoo.com</p>
                    </div>
                </div>
                <div className="single-contact-info">
                    <div className="icon">
                        <FaMapMarkerAlt />
                    </div>
                    <div className="contact-info">
                        <span>Office Address</span>
                        <p>Jl. Ahmad Yani KM 12.8 Gambut, Banjarmasin 70652, South Kalimantan</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WidGetTouch;
